import { render, staticRenderFns } from "./modal-policy-course.vue?vue&type=template&id=589af051&scoped=true"
import script from "./modal-policy-course.vue?vue&type=script&lang=js"
export * from "./modal-policy-course.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589af051",
  null
  
)

export default component.exports